import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import UserAvatar from '../assets/images/useravatar.webp';
import { DropDown, Line } from '@/components';
import AppSwitcher, { AppId } from './AppSwitcher';
import { useAuth } from '../context/AuthContext';
import strings from '../language/Swedish';
import useUser from '../api/queries/useUser';

const StyledSidebar = styled.aside`
  ${tw`hidden md:flex flex-col h-screen w-72 flex-none p-2 z-10 bg-white/40 backdrop-blur-xl border-r border-white/80`};
`;

const TopContainer = styled.div`
  ${tw`flex-none overflow-hidden pl-1`};
`;

const ContentContainer = styled.div`
  ${tw`flex flex-col flex-1 gap-3 overflow-y-auto px-1 py-2`};
`;

const BottomContainer = styled.div`
  ${tw`flex-none overflow-hidden`};
`;

interface Props {
  currentApp: AppId;
  children?: ReactNode;
}

const AppSidebar: FC<Props> = ({ currentApp, children }) => {
  const { logout } = useAuth();
  const { data: userData } = useUser();

  const bottomMenuData = {
    trigger: {
      img: UserAvatar,
      alt: 'User avatar',
      text: userData ? userData.email : '',
      rounded: true,
    },
    items: [
      {
        text: strings.sidebar.support,
        link: `mailto:${strings.login.emailUrl.email}`,
      },
      { text: strings.login.logout, handleClick: () => logout() },
    ],
  };

  return (
    <StyledSidebar>
      <TopContainer>
        <AppSwitcher currentApp={currentApp} />
      </TopContainer>
      <Line />
      <ContentContainer>{children}</ContentContainer>
      <Line />
      <BottomContainer>
        <DropDown data={bottomMenuData} bottomLine={true} imgSize="small" />
      </BottomContainer>
    </StyledSidebar>
  );
};

export default AppSidebar;
